module.exports = __webpack_public_path__ + "img/KeyPal-2.33c58a97.png";